import React, { Component } from 'react';
import { connect } from 'react-redux';

import getPossessionsCategories from '../../selectors/myself/getPossessionsCategories';
import PossessionsContext from './PossessionsContext';
import PossessionsComponent from './PossessionsComponent';
import { IAppState } from 'types/app';
import { ICategory } from 'types/possessions';
import { StoryletPhase } from 'types/storylet';

interface State {
  filterString: string,
}

export class PossessionsContainer extends Component<Props, State> {
  static displayName = 'PossessionsContainer';
  state = {
    filterString: '',
  };

  handleFilter = (evt: any) => {
    this.setState({ filterString: evt.target.value });
  };

  render = () => {
    const { categories, isFetching, storyletPhase } = this.props;
    const { filterString } = this.state;
    return (
      <PossessionsContext.Provider
        value={{
          categories,
          filterString,
          currentlyInStorylet: storyletPhase !== 'Available',
          onFilter: this.handleFilter,
        }}
      >
        <PossessionsComponent
          isFetching={isFetching}
        />
      </PossessionsContext.Provider>
    );
  }
}

// PossessionsContainer.displayName = 'PossessionsContainer';

/*
PossessionsContainer.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    // TODO: work out category shape
  })).isRequired,
  isFetching: PropTypes.bool.isRequired,
};
 */
interface Props {
  categories: ICategory[],
  isFetching: boolean,
  storyletPhase: StoryletPhase,
}

// const mapStateToProps = ({ myself: { isFetching } }) => ({ isFetching });
const mapStateToProps = (state: IAppState) => ({
  categories: getPossessionsCategories(state),
  isFetching: state.myself.isFetching,
  storyletPhase: state.storylet.phase,
});

export default connect(mapStateToProps)(PossessionsContainer);